export enum SupportedLanguageEnum {
  Default = 'en',
  English = 'en',
  Spanish = 'es'
}

export enum SchoolType {
  Online = 1,
  Undergrad = 2,
  Grad = 3
}

export enum TopicsType {
  Popular = 'popular',
  Trending = 'trending',
  ImproveYourScore = 'improve_your_score',
  FindASchool = 'find_a_school',
  ExploreCareers = 'explore_careers',
  VocationalTestPrep = 'vocational_test_prep',
  More = 'more'
}

export enum TopicsTypeId {
  Popular = 1,
  Trending = 2,
  ImproveYourScore = 3,
  FindASchool = 4,
  ExploreCareers = 5,
  VocationalTestPrep = 6,
  More = 7
}

export enum KeyboardKey {
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  Enter = 'Enter',
  Escape = 'Escape',
  Home = 'Home',
  End = 'End',
  Alt = 'Alt',
  Space = ' '
}
